export enum UserWidgetType {
  DEAL_CONTINGENT = 'deal_contingent',
  IRA = 'ira',
}
